const artists = {
    Neptune: {
        name: "aliens_gate",
        socials: {
            Instagram: "https://www.instagram.com/aliens_gate",
            Bluesky: "https://bsky.app/profile/aliens.bsky.social"
        }
    },
    Tao: {
        name: "Khaiiiju",
        socials: {
            Instagram: "https://www.instagram.com/khaiiiju/"
        }
    },
    Polyana: {
        name: "Polyana",
        socials: {
            Instagram: "https://www.instagram.com/bunnym0uth_/",
            Bluesky: "https://bsky.app/profile/bunnymouth.bsky.social"
        }
    }
}

export default artists;